<template>
    <ItemIndex
        :singular-name="singularName"
        :plural-name="pluralName"
        :item-type="indexType"
    >
        <template>
            <ItemIndexFilterNotification
                :index-type="indexType"
                :show="filter.show"
                :type="filter.type"
                :term="filter.term"
            />
            <v-data-table
                :search="searchTerm"
                :headers="headers"
                :items="items"
                :items-per-page="10"
                :loading="tableLoading"
            >
                <template #item.name="{ item }">
                    <v-btn
                        x-small
                        :to="'/card/edit/' + item.id"
                        color="primary"
                    >
                        {{ item.name }}
                        <v-icon
                            right
                            x-small
                        >
                            fas fa-edit
                        </v-icon>
                    </v-btn>
                </template>
                <template #item.section.step.name="{ item }">
                    <span v-if="item.section && item.section.step">
                        <v-btn
                            type="button"
                            x-small
                            color="secondary"
                            @click="filterIndex('Step', item)"
                        >
                            {{ item.section.step.name }}
                        </v-btn>
                    </span>
                </template>
                <template #item.section.name="{ item }">
                    <span v-if="item.section">
                        <v-btn
                            type="button"
                            x-small
                            color="secondary"
                            @click="filterIndex('Section', item)"
                        >
                            {{ item.section.name }}
                        </v-btn>
                    </span>
                </template>
                <template #item.page.name="{ item }">
                    <span v-if="item.page">
                        <v-btn
                            type="button"
                            x-small
                            color="secondary"
                            @click="filterIndex('Page', item)"
                        >
                            {{ item.page.name }}
                        </v-btn>
                    </span>
                </template>
                <template #item.published="{ item }">
                    <v-icon
                        small
                        color="primary"
                        v-if="item.published === 1"
                    >
                        fas fa-check-circle
                    </v-icon>
                    <v-icon
                        small
                        color="error"
                        v-else
                    >
                        fas fa-minus-circle
                    </v-icon>
                </template>
            </v-data-table>
        </template>
    </ItemIndex>
</template>

<script>
import ItemIndex from '@/views/Admin/Config/Commonn/ItemIndex';
import ItemIndexBoilerplate from '@/views/Admin/Config/Commonn/ItemIndexBoilerplate';

export default {
    components: { ItemIndex },
    mixins: [ ItemIndexBoilerplate ],

    data() {
        return {
            indexType: 'card',
            singularName: 'Card',
            pluralName: 'Cards',
            responseObject: 'cards',
            headers: [
                {
                    text: 'Name',
                    value: 'name',
                },
                {
                    text: 'Step',
                    value: 'section.step.name',
                },
                {
                    text: 'Section',
                    value: 'section.name',
                },
                {
                    text: 'Page',
                    value: 'page.name',
                },
                {
                    text: 'Level',
                    value: 'level',
                },
                {
                    text: 'Order',
                    value: 'order',
                },
                {
                    text: 'Published',
                    value: 'published',
                    align: 'right',
                },
            ],
        };
    }
};
</script>
